import React from 'react';

const fmt = (v) => new Date(/Z|[+-]\d\d:\d\d$/.test(v) ? v : `${v}Z`).toLocaleString('en-IN', {
  timeZone: 'Asia/Kolkata', day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
});

export default function LoginStatusCell({ ebo }) {
  const s = ebo.loginStatus;
  if (s === 'logged_in') {
    return (
      <div data-testid={`ebo-login-status-${ebo.code}`}>
        <span className="px-2 py-0.5 rounded-full text-[11.5px] font-medium bg-[#E6F2E9] text-[#2f6b41]">Logged in</span>
        <div className="text-[11.5px] text-[#7a6f5c] mt-1" data-testid={`ebo-last-login-${ebo.code}`}>Last: {fmt(ebo.lastLoginAt)} IST</div>
      </div>
    );
  }
  return (
    <div data-testid={`ebo-login-status-${ebo.code}`}>
      <span className="px-2 py-0.5 rounded-full text-[11.5px] font-medium bg-[#FBF0DC] text-[#8a5a12]">Never</span>
      <div className="text-[11.5px] text-[#7a6f5c] mt-1">{s === 'no_login' ? 'No login account yet' : 'Not logged in since tracking began'}</div>
    </div>
  );
}
